import React, { useState } from 'react';
import { Button, Container, Stack, Table, Typography } from '@mui/joy';
import { useLoaderData, useNavigate } from 'react-router';
import { Course } from '../models/course';
import { useAuth } from '../auth/AuthContext';
import { serviceFacade } from '../services/service-facade';

interface CourseDetailsLoaderData {
    course: Course;
}

const CourseDetails = () => {
    const { course } = useLoaderData() as CourseDetailsLoaderData;
    const navigate = useNavigate();
    const { userId, playerId } = useAuth();
    const [copying, setCopying] = useState(false);

    const isOwner = course.ownerPlayerId === playerId;
    const holeCount = course.holes.length;
    const totalPar = course.holes.reduce((sum, h) => sum + h.par, 0);

    const handleCopy = async () => {
        if (!userId || !playerId) {
            navigate('/login');
            return;
        }

        try {
            setCopying(true);
            const copy = await serviceFacade.copyCourse(course.id, playerId);
            navigate(`/courses/${copy.id}`);
        } catch (error) {
            console.error('Error copying course:', error);
        } finally {
            setCopying(false);
        }
    };

    return (
        <Container>
            <Stack spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography level="h2">{course.name}</Typography>
                    {isOwner ? (
                        <Button onClick={() => navigate(`/courses/${course.id}/edit`)}>Edit</Button>
                    ) : (
                        <Button onClick={handleCopy} loading={copying} disabled={copying}>
                            Copy
                        </Button>
                    )}
                </Stack>

                <Typography>
                    Holes: {holeCount} &nbsp;&middot;&nbsp; Total Par: {totalPar}
                </Typography>

                <Table>
                    <thead>
                        <tr>
                            <th>Hole</th>
                            <th>Par</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[...course.holes]
                            .sort((a, b) => a.number - b.number)
                            .map((hole) => (
                                <tr key={hole.number}>
                                    <td>Hole {hole.number}</td>
                                    <td>{hole.par}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </Stack>
        </Container>
    );
};

export default CourseDetails;
